import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Header from './header.jsx';

class LeaderView extends React.Component {

  renderMyRank() {

    if (this.props.myRank) {
      return this.renderMyRank2(this.props.myRank);
    }
  }

  renderBlank() {
    return (
      <tr>
        <td>
        </td>
        <td>
        </td>
        <td>
        </td>
      </tr>
    );
  }

  renderMyRank2(rank) {
    return (
      <tr className="yourRank">
        <td>
          {rank.name}
        </td>
        <td>
          {rank.mmr}
        </td>
        <td>
          {rank.rank}
        </td>
      </tr>
    );
  }

  renderRank(rank) {
    return (
      <tr>
        <td>
          {rank.name}
        </td>
        <td>
          {rank.mmr}
        </td>
        <td>
          {rank.rank}
        </td>
      </tr>
    );
  }

  renderBackPage() {
    if (this.props.pageData.page > this.props.pageData.first) {
      return (
        <a href="#" onClick={() => this.props.clickPage(this.props.pageData.page - 1)}>&laquo;</a>
      );
    }
  }

  renderForwardPage() {

    if (this.props.pageData.page < this.props.pageData.last) {
      return (
        <a href="#" onClick={() => this.props.clickPage(this.props.pageData.page + 1)}>&raquo;</a>
      );
    }
  }

  renderPage(index, isActive) {

    var click = () => this.props.clickPage(index);
    if (!isActive) {
      return (
        <a href="#" onClick={click}>{index}</a>
      );
    }
    else {
      return (
        <a href="#" class="active" onClick={click}>{index}</a>
      );
    }
  }

  renderPagination() {

    var pages = [];
    for (var i = this.props.pageData.first; i < this.props.pageData.last + 1; i++)
      pages.push(this.renderPage(i, i === this.props.pageData.page));

    return (
      <div class="red2">
        <div class="center">
          <div class="pagination">
            {this.renderBackPage()}
            {pages}
            {this.renderForwardPage()}
          </div>
        </div>
      </div>
    );
  }

  render() {

    return (
      <div class="main" id="main">
        <canvas id="backCanvas" class="backCanvas"></canvas>
        <Header clickBack={this.props.clickBack} name="Leaderboards" name="Ranked Leaders"/>

        <div class="middleRanked" id="search">
          <table>
            <tbody>

              <tr>
                <th>
                  Player
                </th>
                <th>
                  MMR
                </th>
                <th>
                  Rank
                </th>
              </tr>

              {this.renderMyRank()}
              {this.renderBlank()}
              {this.props.rankData.map(this.renderRank.bind(this))}
            </tbody>
          </table>
        </div>
        {this.renderPagination()}
      </div>
    );
  }
}

LeaderView.propTypes = {
  clickBack: PropTypes.func,
  clickPage: PropTypes.func,
  myRank: PropTypes.object,
  pageData: PropTypes.object,
  rankData: PropTypes.object,
};

export default LeaderView;